export default function watchViewportInnerHeight() {
    setViewportInnerHeightProperty();
    window.addEventListener('resize', setViewportInnerHeightProperty);
};

const setViewportInnerHeightProperty = function () {
    let visibleHeight = window.innerHeight;
    document.documentElement.style.setProperty('--vh', `${visibleHeight}px`);
};